/**
 * Live Sources Component — Domain interfaces.
 * Maps React Source model to real LiveFeed data from scheduler-aside / LiveFeedRepository.
 */

import { EStreamSourceType } from '../live-feed';

// ── Source Status ───────────────────────────────────────────

/**
 * Live source operational status.
 * In the real system these are derived from LiveFeed availability checks.
 */
export enum LiveSourceStatus {
  Active = 'Active',
  Paused = 'Paused',
  Error = 'Error',
  Idle = 'Idle',
}

// ── Source Model ────────────────────────────────────────────

/**
 * A live input source displayed in the Sources page.
 * Combines basic LiveFeed data with enriched LiveFeedInfo details.
 */
export interface LiveSource {
  id: string;
  name: string;
  status: LiveSourceStatus;
  sourceType?: EStreamSourceType;
  /** Protocol label derived from EStreamSourceType (e.g. 'SRT', 'RTMP', 'HLS'). */
  protocolLabel: string;
  thumbnail: string;
  tenantUniqueId: string;
  /** Stream remote address (IP or hostname). */
  remoteAddress?: string;
  /** Stream remote port. */
  remotePort?: number;
  /** Stream URL (for pull sources). */
  streamUrl?: string;
  /** Total latency in milliseconds (from API TotalLatencyMs). */
  totalLatencyMs?: number;
  /** Display address: remoteAddress + ':' + remotePort (from API RemoteAddress, RemotePort). */
  address?: string;
}

// ── Filter Types ────────────────────────────────────────────

export type LiveSourceStatusFilter = LiveSourceStatus | 'All';
export type LiveSourceProtocolFilter = EStreamSourceType | 'All';
